const statusIndicatorType = {
  pending: 'pending',
  published: 'published',
  live: 'live',
  scheduled: 'scheduled',
  unpublished: 'unpublished',
  expired: 'expired',
};

export default statusIndicatorType;
